import { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { miPerfilApi, actualizarPerfilApi } from '../api';

const Logo = ({ white = false }) => (
  <svg width="155" height="46" viewBox="0 0 160 60">
    <ellipse cx="28" cy="30" rx="22" ry="22" fill="none" stroke={white ? "#5aabdd" : "#3a7fc1"} strokeWidth="7" strokeDasharray="115 25" strokeDashoffset="15"/>
    <ellipse cx="28" cy="30" rx="14" ry="14" fill="none" stroke={white ? "#6dd68a" : "#4caf50"} strokeWidth="5" strokeDasharray="65 23" strokeDashoffset="-10"/>
    <text x="56" y="36" fontSize="22" fill={white ? "#ffffff" : "#4a9fd4"} fontWeight="700" fontFamily="Arial,sans-serif">euroswiss</text>
  </svg>
);

export { Logo };

export default function Layout({ children, titulo }) {
  const { usuario, logout, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [modalPerfil, setModalPerfil] = useState(false);
  const [perfil, setPerfil] = useState(null);
  const [formPerfil, setFormPerfil] = useState({ nombre: '', apellido: '', password_actual: '', password_nueva: '', confirmar: '' });
  const [guardando, setGuardando] = useState(false);
  const [mensajePerfil, setMensajePerfil] = useState('');
  const [errorPerfil, setErrorPerfil] = useState('');
  const menuRef = useRef(null);

  const handleLogout = () => { logout(); navigate('/login'); };

  const abrirPerfil = async () => {
    setMenuAbierto(false);
    setMensajePerfil('');
    setErrorPerfil('');
    try {
      const res = await miPerfilApi();
      setPerfil(res.data);
      setFormPerfil({ nombre: res.data.nombre, apellido: res.data.apellido, password_actual: '', password_nueva: '', confirmar: '' });
    } catch(err) { console.error(err); }
    setModalPerfil(true);
  };

  const guardarPerfil = async (e) => {
    e.preventDefault();
    setMensajePerfil('');
    setErrorPerfil('');
    if (formPerfil.password_nueva && formPerfil.password_nueva !== formPerfil.confirmar)
      return setErrorPerfil('Las contrasenas no coinciden');
    setGuardando(true);
    try {
      await actualizarPerfilApi({
        nombre: formPerfil.nombre,
        apellido: formPerfil.apellido,
        password_actual: formPerfil.password_actual || undefined,
        password_nueva: formPerfil.password_nueva || undefined,
      });
      setMensajePerfil('Perfil actualizado correctamente');
      const token = localStorage.getItem('token');
      login(token, { ...usuario, nombre: formPerfil.nombre, apellido: formPerfil.apellido });
    } catch(err) {
      setErrorPerfil(err.response?.data?.error || 'Error al actualizar');
    } finally { setGuardando(false); }
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuAbierto(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const menu = [
    { path: '/',                 label: 'Dashboard',        icon: '▦' },
    { path: '/tickets',          label: 'Tickets',          icon: '🎫' },
    { path: '/clientes',         label: 'Clientes',         icon: '🏥' },
    { path: '/implementaciones', label: 'Implementaciones', icon: '🔧' },
    { path: '/reportes',         label: 'Reportes',         icon: '📊' },
    { path: '/usuarios',         label: 'Usuarios',         icon: '👥', soloAdmin: true },
  ];

  const iniciales = usuario ? `${usuario.nombre[0]}${usuario.apellido[0]}` : 'U';

  const fechaFormateada = new Date().toLocaleDateString('es-AR', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
  }).replace(/^\w/, c => c.toUpperCase());

  const inp = {
    width: '100%', padding: '9px 12px', border: '1px solid #ddd',
    borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none'
  };
  const lbl = { display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 5 };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#0f0f0f' }}>

      <div style={{ width: 220, flexShrink: 0, background: '#111', borderRight: '1px solid #1f1f1f', padding: '1.25rem 0', display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
        <div style={{ padding: '0 1rem', marginBottom: '1.5rem' }}>
          <Logo />
          <div style={{ fontSize: 11, color: '#666', marginTop: 2, paddingLeft: 2 }}>Soporte tecnico</div>
        </div>
        <nav style={{ flex: 1 }}>
          {menu.map(item => {
            if (item.soloAdmin && usuario?.rol !== 'admin') return null;
            const activo = location.pathname === item.path;
            return (
              <Link key={item.path} to={item.path} style={{ textDecoration: 'none' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 18px', margin: '2px 8px', borderRadius: 8, fontSize: 15, cursor: 'pointer', background: activo ? '#1a2a3a' : 'transparent', color: activo ? '#4a9fd4' : '#aaa', fontWeight: activo ? 600 : 400, borderLeft: activo ? '3px solid #1a6fbb' : '3px solid transparent', transition: 'all 0.15s' }}>
                  <span style={{ fontSize: 17, width: 22, textAlign: 'center' }}>{item.icon}</span>
                  {item.label}
                </div>
              </Link>
            );
          })}
        </nav>
        <div style={{ borderTop: '1px solid #1f1f1f', padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#1a2a3a', color: '#4a9fd4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 600, flexShrink: 0 }}>{iniciales}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: '#ddd', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{usuario?.nombre} {usuario?.apellido}</div>
            <div style={{ fontSize: 11, color: '#666' }}>{usuario?.rol}</div>
          </div>
        </div>
      </div>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, height: '100vh', overflow: 'hidden' }}>
        <div style={{ background: '#111', borderBottom: '1px solid #1f1f1f', padding: '11px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div style={{ fontSize: 13, color: '#bbb' }}>
            Panel / <span style={{ color: '#fff', fontWeight: 600 }}>{titulo}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ fontSize: 12, color: '#ccc' }}>{fechaFormateada}</div>
            <div style={{ position: 'relative', cursor: 'pointer' }}>
              <span style={{ fontSize: 18 }}>🔔</span>
              <div style={{ width: 8, height: 8, background: '#e24b4a', borderRadius: '50%', position: 'absolute', top: 0, right: 0 }}/>
            </div>
            <div ref={menuRef} style={{ position: 'relative' }}>
              <div onClick={() => setMenuAbierto(!menuAbierto)} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', padding: '4px 8px', borderRadius: 8, background: menuAbierto ? '#1a2a3a' : 'transparent', transition: 'background 0.15s' }}>
                <div style={{ width: 30, height: 30, borderRadius: '50%', background: '#1a2a3a', color: '#4a9fd4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600 }}>{iniciales}</div>
                <span style={{ fontSize: 13, fontWeight: 500, color: '#ddd' }}>{usuario?.nombre}</span>
                <span style={{ fontSize: 10, color: '#666' }}>▾</span>
              </div>
              {menuAbierto && (
                <div style={{ position: 'absolute', right: 0, top: '110%', background: '#1a1a1a', border: '1px solid #2a2a2a', borderRadius: 10, minWidth: 210, zIndex: 999, boxShadow: '0 8px 24px rgba(0,0,0,0.5)', overflow: 'hidden' }}>
                  <div style={{ padding: '12px 16px', borderBottom: '1px solid #222' }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#fff' }}>{usuario?.nombre} {usuario?.apellido}</div>
                    <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>{usuario?.username}</div>
                    <div style={{ fontSize: 11, color: '#4a9fd4', marginTop: 2 }}>{usuario?.rol}</div>
                  </div>
                  <div onClick={abrirPerfil} style={{ padding: '11px 16px', fontSize: 13, color: '#ccc', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10 }} onMouseEnter={e => e.currentTarget.style.background = '#222'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <span style={{ fontSize: 15 }}>👤</span> Mis datos
                  </div>
                  <div onClick={handleLogout} style={{ padding: '11px 16px', fontSize: 13, color: '#f87171', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10, borderTop: '1px solid #222' }} onMouseEnter={e => e.currentTarget.style.background = '#2a1a1a'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <span style={{ fontSize: 15 }}>🚪</span> Cerrar sesion
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div style={{ flex: 1, padding: '1.5rem 24px', overflowY: 'auto' }}>
          {children}
        </div>

        <div style={{ borderTop: '1px solid #1a1a1a', padding: '10px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <span style={{ fontSize: 11, color: '#888' }}>Euroswiss S.A. 2026 · Sistema de soporte tecnico VUEPACS</span>
          <span style={{ fontSize: 11, color: '#888' }}>Desarrollado por Pablo Facundo Azar</span>
        </div>
      </div>

      {modalPerfil && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: '1.75rem', width: '100%', maxWidth: 460 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
              <p style={{ fontWeight: 700, fontSize: 16, color: '#111' }}>Mis datos</p>
              <button onClick={() => setModalPerfil(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#aaa' }}>✕</button>
            </div>
            <form onSubmit={guardarPerfil}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Nombre *</label>
                  <input type="text" value={formPerfil.nombre} onChange={e => setFormPerfil({ ...formPerfil, nombre: e.target.value })} required style={inp}/>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Apellido *</label>
                  <input type="text" value={formPerfil.apellido} onChange={e => setFormPerfil({ ...formPerfil, apellido: e.target.value })} required style={inp}/>
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={lbl}>Usuario</label>
                <input type="text" value={perfil?.username || ''} disabled style={{ ...inp, background: '#eee', color: '#888', cursor: 'not-allowed' }}/>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={lbl}>Email</label>
                <input type="text" value={perfil?.email || ''} disabled style={{ ...inp, background: '#eee', color: '#888', cursor: 'not-allowed' }}/>
              </div>
              <div style={{ height: 1, background: '#eee', margin: '16px 0' }}/>
              <p style={{ fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 12 }}>Cambiar contrasena <span style={{ fontSize: 11, color: '#aaa', fontWeight: 400 }}>(opcional)</span></p>
              <div style={{ marginBottom: 14 }}>
                <label style={lbl}>Contrasena actual</label>
                <input type="password" placeholder="••••••••" value={formPerfil.password_actual} onChange={e => setFormPerfil({ ...formPerfil, password_actual: e.target.value })} style={inp}/>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Nueva contrasena</label>
                  <input type="password" placeholder="••••••••" value={formPerfil.password_nueva} onChange={e => setFormPerfil({ ...formPerfil, password_nueva: e.target.value })} style={inp}/>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Confirmar</label>
                  <input type="password" placeholder="••••••••" value={formPerfil.confirmar} onChange={e => setFormPerfil({ ...formPerfil, confirmar: e.target.value })} style={inp}/>
                </div>
              </div>
              {errorPerfil   && <p style={{ color: '#e24b4a', fontSize: 12, marginBottom: 12 }}>{errorPerfil}</p>}
              {mensajePerfil && <p style={{ color: '#16a34a', fontSize: 12, marginBottom: 12 }}>{mensajePerfil}</p>}
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => setModalPerfil(false)} style={{ padding: '9px 20px', background: 'transparent', color: '#333', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}>Cancelar</button>
                <button type="submit" disabled={guardando} style={{ padding: '9px 20px', background: '#1a6fbb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                  {guardando ? 'Guardando...' : 'Guardar cambios'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}